<template>
  <div class="feedback">
    <van-popup :close-on-click-overlay="false" v-model="evaluateVisible">
      <div class="content-box" v-if="!evaluateDetail">
        <h1>课程评价</h1>
        <div class="close" @click="close"></div>
        <div class="rate-div">
          <van-rate
            v-model="rateValue"
            :size="20"
            :icon="require('../../../assets/img/learningGuidePage/star.png')"
            :void-icon="require('../../../assets/img/learningGuidePage/void_star.png')"
          />
        </div>
        <div class="txt">
          <textarea v-model="evaluation" maxlength="100" placeholder="请输入评价" />
          <span class="evaluation-count">{{ evaluation.length }}/100</span>
        </div>
        <div class="foot" :class="{ active: submitting }" @click="submit">提交</div>
      </div>
      <div class="content-box" v-else>
        <h1>课程评价</h1>
        <div class="close" @click="close"></div>
        <div class="rate-div">
          <van-rate
            v-model="evaluateDetail.evaluationStar * 1"
            :size="20"
            :icon="require('../../../assets/img/learningGuidePage/mini_star.png')"
            void-icon=""
            readonly
          />
        </div>
        <div class="card-content">{{ evaluateDetail.evaluationContent }}</div>
        <div class="card-reply" v-if="evaluateDetail.replyContent">
          <div class="reply-title">
            <span>启小航回复</span>
            <span class="reply-time">{{ evaluateDetail.replyTime | timeHandleFilter }}</span>
          </div>
          <div class="reply-content">
            {{ evaluateDetail.replyContent }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { reqProductEvaluation, reqGetEvaluationGuidance } from '@/api/learningGuidePage';
import moment from 'moment';

export default {
  props: ['visible', 'resourceId', 'resourceType', 'resourceName', 'productId'],
  data() {
    return {
      evaluateVisible: this.visible,
      rateValue: 0,
      evaluation: '',
      btnInfo: {
        text: '提交',
        loading: false,
        disabled: false,
      },
      productDetail: {},
      submitting: false,
      evaluateDetail: null,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  filters: {
    timeHandleFilter(time) {
      return moment(time).format('YYYY/MM/DD HH:mm'); // 重置时间格式
    },
  },
  watch: {
    visible() {
      this.evaluateVisible = this.visible;
    },
    resourceId() {
      this.evaluateDetail = null;
      this.rateValue = 0;
      this.evaluation = '';
      this.checkEvaluate();
    },
  },
  mounted() {
    this.checkEvaluate();
  },
  methods: {
    close() {
      this.$emit('evaluateClose');
    },
    // 是否评价过
    async checkEvaluate() {
      const params = `?resourceId=${this.resourceId}&resourceType=${this.resourceType}&entryType=2`;
      const { data } = await reqGetEvaluationGuidance(params);
      this.evaluateDetail = data;
      console.log(this.evaluateDetail, 'evaluateDetail');
    },
    async submit() {
      if (this.submitting) {
        return;
      }
      if (!this.rateValue) {
        this.$toast('请选择评价等级！');
        return;
      }
      if (!this.evaluation) {
        this.$toast('请输入评价内容！');
        return;
      }
      this.submitting = true;
      const param = {
        evaluationContent: this.evaluation,
        evaluationStar: this.rateValue,
        resourceId: this.resourceId,
        resourceType: this.resourceType,
        resourceName: this.resourceName,
        productId: this.productId,
        entryType: 2,
      };
      const { code, msg } = await reqProductEvaluation(param);
      this.close();
      if (code === 0) {
        this.checkEvaluate();
        this.$toast('评价成功');
      } else {
        this.$toast(msg || '评价失败');
      }
      this.submitting = false;
    },
    changeType(data) {
      return Number(data);
    },
  },
};
</script>
<style scoped lang="scss">
.feedback {
  width: 100%;
  ::v-deep .van-overlay{
    z-index: 1000;
  }
  .van-popup.van-popup--center {
    box-sizing: border-box;
    width: 84.5%;
    background: #fff;
    border-radius: 7px;
  }
  .content-box {
    position: relative;
    width: 100%;
    padding-bottom: 34px;
    > h1 {
      padding: 26px 0;
      color: #333;
      font-weight: 500;
      font-size: 26px;
      text-align: center;
    }
    .close {
      position: absolute;
      top: 34px;
      right: 34px;
      width: 26px;
      height: 26px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/close.png');
      background-size: 100%;
    }
    .rate-div {
      width: 100%;
      text-align: center;
    }
    .txt {
      position: relative;
      textarea {
        display: block;
        box-sizing: border-box;
        width: 540px;
        height: 254px;
        margin: 26px auto;
        padding: 26px;
        font-size: 24px;
        line-height: 36px;
        background: #f6f7f9;
        border-color: #f6f7f9;
        border-radius: 14px;
        outline: none;
        -webkit-appearance: none;
        resize: none;
      }

      .evaluation-count {
        position: absolute;
        right: 26px;
        bottom: 16px;
        display: block;
        width: 100%;
        padding-right: 36px;
        color: #787878;
        font-size: 24px;
        text-align: right;
      }
    }
    .card-content {
      padding: 26px 34px;
      color: #333;
      font-weight: 400;
      font-size: 24px;
      line-height: 34px;
      word-break: break-all;
    }
    .card-reply {
      margin: 0 34px;
      padding: 26px;
      background: #f6f7f9;
      border-radius: 14px;
      .reply-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 20px;
        span {
          color: #333;
          font-weight: 500;
          font-size: 24px;
        }
        .reply-time {
          color: #999;
          font-weight: 400;
          font-size: 24px;
        }
      }
      .reply-content {
        color: #333;
        font-weight: 400;
        font-size: 24px;
        line-height: 36px;
        word-break: break-all;
      }
    }
    .foot {
      display: block;
      width: 188px;
      height: 62px;
      margin: 0 auto 34px;
      color: #fff;
      font-weight: 400;
      font-size: 26px;
      line-height: 62px;
      text-align: center;
      background: #ff7f41;
      border-radius: 38px;
    }
    .foot.active {
      opacity: 0.5;
    }
  }
}
</style>
